// Styles
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';

import { mdi } from "vuetify/iconsets/mdi";
import { customSVGs } from "../assets/custom-svg";

// Vuetify
import { createVuetify } from 'vuetify';
import { sv, de } from 'vuetify/locale'

import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

export default createVuetify({
    theme: false,
    components,
    directives,
    icons: {
        defaultSet: "mdi",
        sets: {
          mdi,
          custom: customSVGs,
        },
      },
})
